import { childToProjectDataUtils, IProjectData, ProjectContext } from "@droid/project-interface";
import { Box, Button, Grid2 } from "@mui/material";
import { useRouter } from "next/router";
import { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";
import { projectUtils } from "../../utils/projectUtils";
import { DeleteProjectButton } from "../components/DeleteProjectButton";
function ProjectName({ project }: PropsWithChildren & { project: IProjectData }) {
    const router = useRouter()
    const { t } = useTranslation('droid-project/project/ui/project/content')
    function edit() {
        const path = `/project-editor?id=${project.id}`
        router.push(path, undefined, {shallow: true})
    }
    return (
        <Grid2 container spacing={2} sx={{ width: "100%" }}
        >
            <Grid2 size={"grow"}>
                <span >{projectUtils.getProjectName(project)}</span>
            </Grid2>
            <Grid2 container spacing={2}>
                <Button
                    {...childToProjectDataUtils.getProjectElementsId({ project }, 'project-list-edit-btn')}
                   
                    data-listof-project-list-edit-btn-id={project.id} 
                    id="project-simple-title-list-edit-btn" 
                    data-id="project-simple-title-list-edit-btn" 
                    onClick={edit}>{t('content.project.edit')}</Button>
                <DeleteProjectButton />
            </Grid2>
        </Grid2>
    )
}

export function ProjectUI({ project }: PropsWithChildren & { project: IProjectData }) {
    return (
        <ProjectContext.Provider value={project}>
            <Box sx={{ width: "100%", backgroundColor: "#f0f0f0", padding: 1 }}
                data-id={project.id}
                {...childToProjectDataUtils.getProjectElementsId({ project })}>
                <ProjectName project={project} />
            </Box>
        </ProjectContext.Provider>
    )
}